import { defineMessages } from 'react-intl';

export default defineMessages({
  createdBy: {
    id: 'Content created by',
    defaultMessage: 'Content created by',
  },
  sponsoredBy: {
    id: 'and sponsored by',
    defaultMessage: 'and sponsored by',
  },
});
